import React, { Component } from 'react';

import '../../styles/ProjectCardSummary.css';

export default class ProjectCopyLoadingCard extends Component {

  render() {
    return (
      <div className="card project-card" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div className="project-details">
          <p style={{ textAlign: 'center' }}>
            <i className="fa fa-spinner fa-pulse fa-5x fa-fw"></i>
            <span style={{ display: 'block', marginTop: 20 }}>
              Copying Project...
            </span>
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/cards/ProjectCopyLoadingCard.js